import React from 'react';

import ProjectCard from '../../components/ProjectCard';

import projectCardContent from './object';

import '../../../node_modules/slick-carousel/slick/slick.css';
import '../../../node_modules/slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';

import './styles.css';

var sliderSettings = {
    arrows: true,
    dots: true,
    infinite: true,
    centerPadding: "10px",
    speed: 100,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                infinite: true,
                centerPadding: "10px",
                speed: 100,
                slidesToShow: 2,
                slidesToScroll: 2,
            }
        },
        {
            breakpoint: 767,
            settings: {
                autoplay: true,
                autoplaySpeed: 10000,
                infinite: true,
                centerPadding: "10px",
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }
    ]
};

export default function Projects() {
    return (
        <div className="projects-container" id="projects">
            <div className="projects-title">
                <h1>Projetos</h1>
            </div>
            <h2 className="projects-description">
                Aqui estão alguns de meus projetos e certificações
            </h2>
            <div className="projects-content">
                <Slider {...sliderSettings}>
                    {
                        projectCardContent.map(content => {
                            return (
                                <ProjectCard content={content} />
                            );
                        })
                    }
                </Slider>
            </div>
        </div>
    );
}